// components/EventSummary/EventSummary.js

import React from 'react';
import styled from 'styled-components';
import DateAndLocation from './DateAndLocation';
import Attendees from './Attendees';
import PastEventBanner from './PastEventBanner';
import { isEventPast } from '../../utils/dateUtils';

const EventSummary = ({
  date,
  location,
  shortLocation,
  mapCoordinates,
  attendees,
  attendeesCount,
  organizer,
  organizerVehicle,
  onShowAllAttendees,
  isLoggedIn,
  eventEndDate,
}) => {
  const eventHasPassed = isEventPast(eventEndDate);
  return (
    <>
      {eventHasPassed && (
        <PastEventBanner eventEndDate={eventEndDate} />
      )}
      <DateAndLocation
        date={date}
        location={location}
        shortLocation={shortLocation}
        mapCoordinates={mapCoordinates}
      />
      <Attendees
        attendees={attendees}
        attendeesCount={attendeesCount}
        organizer={organizer}
        organizerVehicle={organizerVehicle}
        onShowAllAttendees={onShowAllAttendees}
        isLoggedIn={isLoggedIn}
      />
    </>
  );
};

export default EventSummary;
